import React, { useState } from "react";
import { Row, Col, Form, FormGroup, Label, Input } from "reactstrap";
import { addWaitlister } from "../api"; // Adjust the path as needed

const WaitlistForm = ({ selectedExperiment }) => {
  const [formData, setFormData] = useState({ name: "", email: "" });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        name: formData.name,
        email: formData.email,
        waitlist_version: selectedExperiment?.waitlist_version, // Use selected experiment version
        waitlist_name: selectedExperiment?.waitlist_name, // Use selected experiment name
      };
      await addWaitlister(data); // Replace with your actual API call
      setMessage("You have been added to the waitlist!");
      setFormData({ name: "", email: "" });
    } catch (error) {
      setMessage("Let's get started with your name and email.");
    }
  };
  console.log("selectedExperiment", selectedExperiment);
  return (
    <React.Fragment>
      <Form
        method="post"
        name="contact-form"
        id="contact-form"
        onSubmit={handleSubmit}
      >
        <Row>
          <Col sm={12} lg={6}>
            <FormGroup className="mt-3">
              <Label className="contact-label">Name</Label>
              <Input
                name="name"
                id="name"
                className="form-control"
                type="text"
                value={formData.name}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
          <Col sm={12} lg={6}>
            <FormGroup className="mt-3">
              <Label className="contact-label">Email</Label>
              <Input
                name="email"
                id="email"
                className="form-control"
                type="text"
                value={formData.email}
                onChange={handleChange}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="mt-3 text-right">
            <Input
              id="submit"
              name="send"
              color="primary"
              className="submitBnt btn btn-primary btn-round"
              value={selectedExperiment ? selectedExperiment.CTA : "Loading..."}
              type="submit"
              style={{
                width: "100%",
                color: "#fff",
                backgroundColor: "red !important",
              }}
            />
            <div id="simple-msg">{message}</div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  );
};

export default WaitlistForm;
